import { useState, useEffect, useRef } from 'react';
import './ScrollBar.css';
import { titleColor, backgroundMainColor, backgroundSubColor, gridCellBackgroundColor, gridCellFontColor } from './Color';

function Grid({ cellData, columnDictionary = {}, maxRowHeight = 60 }) { 
  const fontSize = 20;
  const rowHeight = fontSize * 2;
  const gridGap = 5;
  const dataGridCellStyle = {
    backgroundColor: gridCellBackgroundColor,
    borderRadius: '7px',
    color: gridCellFontColor,
    textAlign: 'center', 
    fontSize: fontSize, 
    height: rowHeight,
    paddingLeft: 10,
    paddingRight: 10,
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };
  const textStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis', 
    whiteSpace: 'nowrap'
  };
  const columnStyle = {
    ...dataGridCellStyle,
    backgroundColor: backgroundSubColor,
    color: titleColor,
    fontWeight: 'bold', 
  };
  const columnNameArray = Object.keys(columnDictionary);
  let rowSpan = false;
  const rowSpanColumnArray = [];
  let rawData = [];
  let rowCount = 10;

  const [dataGridStyle, setDataGridStyle] = useState({
    display: 'grid',
    gap: gridGap,
    backgroundColor: backgroundMainColor,
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    gridTemplateColumns: `repeat(5, auto)`,
    alignContent: 'start',
    whiteSpace: 'nowrap',
    height: '100%'
  });

  const gridDivRef = useRef(null);

  /*useEffect(() => {
    apiUrlRef.current = apiUrl;

    for (const column in columnDictionary) {
      if (columnDictionary[column].rowSpan) {
        rowSpan = true;
        rowSpanColumnArray.push(column);
      }
    }
    
    Inquiry();

    function Resize() {
      const totalGapHeight = (rowCount - 1) * gridGap;
      let rowHeight = (gridDivRef.current.offsetHeight - totalGapHeight) / rowCount;
      rowHeight = rowHeight > maxRowHeight ? maxRowHeight: rowHeight;
      const fontSize = rowHeight * 0.5;

      setColumn(columnNameArray.map((columnName, index) => (
        <div key={'column'+index} style={{ ...columnStyle, fontSize: fontSize, height: rowHeight }}>
          <span style={textStyle}>{columnDictionary[columnName].label}</span>
        </div>
      )));

      if (rowSpan) {
        const invisibleDataIndexArray = [];
        const rowSpanDictionary = {};
        for (let i=0; i<rawData.length; i++) {          
          if (rawData[i] !== '' && rawData[i] !== null) {
            FindSameValue(i, i);
          }
        }
        function FindSameValue(index, parentIndex) {
          if (!rowSpanColumnArray.includes(columnNameArray[index % columnNameArray.length])) {
            return;
          }

          const nextDataIndex = index + columnNameArray.length;
          if (nextDataIndex < rawData.length && !invisibleDataIndexArray.includes(nextDataIndex)) {
            if (rawData[index] === rawData[nextDataIndex]) {
              if (rowSpanDictionary[parentIndex] === undefined) {
                rowSpanDictionary[parentIndex] = 2;
              } else {
                rowSpanDictionary[parentIndex] += 1;
              }

              invisibleDataIndexArray.push(nextDataIndex);
              FindSameValue(nextDataIndex, parentIndex);
            }
          }
        }

        setData(rawData.map((data, index) => (
          !invisibleDataIndexArray.includes(index) && <div key={'data'+index} style={{ ...dataGridCellStyle, height: rowSpanDictionary[index] ? rowHeight * rowSpanDictionary[index] + ((rowSpanDictionary[index] - 1) * gridGap) : rowHeight, gridRow: rowSpanDictionary[index] ? `span ${rowSpanDictionary[index]}` : `span 1` }}>
            <span style={textStyle}>{data}</span>
          </div>
        )));
      } else{
        setData(rawData.map((data, index) => (
          <div key={'data'+index} style={{ ...dataGridCellStyle, fontSize: fontSize, height: rowHeight }}>
            <span style={textStyle}>{data}</span>
          </div>
        )));
      }
    }

    window.addEventListener('resize', Resize);
    
    return () => {
      window.removeEventListener('resize', Resize);
    };
  }, [apiUrl]);*/

  useEffect(() => {
    Inquiry();

    function Resize() {
      const totalGapHeight = (rowCount - 1) * gridGap;
      let rowHeight = (gridDivRef.current.offsetHeight - totalGapHeight) / rowCount;
      rowHeight = rowHeight > maxRowHeight ? maxRowHeight: rowHeight;
      const fontSize = rowHeight * 0.5;

      setColumn(columnNameArray.map((columnName, index) => (
        <div key={'column'+index} style={{ ...columnStyle, fontSize: fontSize, height: rowHeight }}>
          <span style={textStyle}>{columnDictionary[columnName].label}</span>
        </div>
      )));

      if (rowSpan) {
        const invisibleDataIndexArray = [];
        const rowSpanDictionary = {};
        for (let i=0; i<rawData.length; i++) {          
          if (rawData[i] !== '' && rawData[i] !== null) {
            FindSameValue(i, i);
          }
        }
        function FindSameValue(index, parentIndex) {
          if (!rowSpanColumnArray.includes(columnNameArray[index % columnNameArray.length])) {
            return;
          }

          const nextDataIndex = index + columnNameArray.length;
          if (nextDataIndex < rawData.length && !invisibleDataIndexArray.includes(nextDataIndex)) {
            if (rawData[index] === rawData[nextDataIndex]) {
              if (rowSpanDictionary[parentIndex] === undefined) {
                rowSpanDictionary[parentIndex] = 2;
              } else {
                rowSpanDictionary[parentIndex] += 1;
              }

              invisibleDataIndexArray.push(nextDataIndex);
              FindSameValue(nextDataIndex, parentIndex);
            }
          }
        }

        setData(rawData.map((data, index) => (
          !invisibleDataIndexArray.includes(index) && <div key={'data'+index} style={{ ...dataGridCellStyle, height: rowSpanDictionary[index] ? rowHeight * rowSpanDictionary[index] + ((rowSpanDictionary[index] - 1) * gridGap) : rowHeight, gridRow: rowSpanDictionary[index] ? `span ${rowSpanDictionary[index]}` : `span 1` }}>
            <span style={textStyle}>{data}</span>
          </div>
        )));
      } else{
        setData(rawData.map((data, index) => (
          <div key={'data'+index} style={{ ...dataGridCellStyle, fontSize: fontSize, height: rowHeight }}>
            <span style={textStyle}>{data}</span>
          </div>
        )));
      }
    }

    window.addEventListener('resize', Resize);
    
    return () => {
      window.removeEventListener('resize', Resize);
    };
  }, [cellData]);

  async function Inquiry() {
    const nowRowCount = cellData.length + 1;
    rowCount = nowRowCount;

    if (!gridDivRef.current) {
      return;
    }
    
    const totalGapHeight = (nowRowCount - 1) * gridGap;
    let rowHeight = (gridDivRef.current.offsetHeight - totalGapHeight) / nowRowCount;
    rowHeight = rowHeight > maxRowHeight ? maxRowHeight: rowHeight;
    const fontSize = rowHeight * 0.5;

    setDataGridStyle((previous => {
      return { ...previous, gridTemplateColumns: `repeat(${columnNameArray.length}, auto)` };
    }));

    setColumn(columnNameArray.map((columnName, index) => (
      <div key={'column'+index} style={{ ...columnStyle, fontSize: fontSize, height: rowHeight }}>
        <span style={textStyle}>{columnDictionary[columnName].label}</span>
      </div>
    )));

    const dataArray = [];
    for (const data of cellData) {
      for (const key in data) {
        if (columnNameArray.includes(key)) {
          if (isNaN(Number(data[key])) || data[key] === '' || data[key] === null) {
            dataArray.push(data[key]);
          } else {
            dataArray.push(Number(data[key]).toLocaleString());
          }
        }
      }
    }
    rawData = dataArray;

    if (rowSpan) {
      const invisibleDataIndexArray = [];
      const rowSpanDictionary = {};
      for (let i=0; i<dataArray.length; i++) {          
        if (dataArray[i] !== '' && dataArray[i] !== null) {
          FindSameValue(i, i);
        }
      }
      function FindSameValue(index, parentIndex) {
        if (!rowSpanColumnArray.includes(columnNameArray[index % columnNameArray.length])) {
          return;
        }

        const nextDataIndex = index + columnNameArray.length;
        if (nextDataIndex < dataArray.length && !invisibleDataIndexArray.includes(nextDataIndex)) {
          if (dataArray[index] === dataArray[nextDataIndex]) {
            if (rowSpanDictionary[parentIndex] === undefined) {
              rowSpanDictionary[parentIndex] = 2;
            } else {
              rowSpanDictionary[parentIndex] += 1;
            }

            invisibleDataIndexArray.push(nextDataIndex);
            FindSameValue(nextDataIndex, parentIndex);
          }
        }
      }

      setData(dataArray.map((data, index) => (
        !invisibleDataIndexArray.includes(index) && <div key={'data'+index} style={{ ...dataGridCellStyle, fontSize: fontSize, height: rowSpanDictionary[index] ? rowHeight * rowSpanDictionary[index] + ((rowSpanDictionary[index] - 1) * gridGap) : rowHeight, gridRow: rowSpanDictionary[index] ? `span ${rowSpanDictionary[index]}` : `span 1` }}>
          <span style={textStyle}>{data}</span>
        </div>
      )));
    } else{
      setData(dataArray.map((data, index) => (
        <div key={'data'+index} style={{ ...dataGridCellStyle, fontSize: fontSize, height: rowHeight }}>
          <span style={textStyle}>{data}</span>
        </div>
      )));
    }
  }

  const [column, setColumn] = useState(<></>);

  const [data, setData] = useState(<></>);

  return (
    <div onContextMenu={(event)=>{ event.preventDefault(); }} style={{ userSelect: 'none', width: '100%', height: '100%', backgroundColor: backgroundMainColor }}>
      <div ref={gridDivRef} style={dataGridStyle}>
        {
          column
        }
        {
          data
        }
      </div>
    </div>
  );
}

export default Grid;